// gum-wire tokens as the api returns them (`0x` + tag byte + address, architecture §5.4):
// `01` EVM (20 bytes), `02` SVM (32 bytes), `03` Sui (length byte + coin type).

import type { Family } from "./chains";
import { suiCoinFromWire } from "./sui";

const B58 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";

export function base58(hex: string): string {
  const h = hex.replace(/^0x/, "");
  let n = BigInt(`0x${h || "0"}`);
  let s = "";
  while (n > 0n) {
    s = B58[Number(n % 58n)] + s;
    n /= 58n;
  }
  for (let i = 0; i + 1 < h.length && h.slice(i, i + 2) === "00"; i += 2) s = "1" + s;
  return s;
}

/** The chain-native address of a wire token (EVM 0x-address, SPL / Jupnet mint, Sui coin type), or the input unchanged. */
export function nativeTokenAddr(wire: string, family: Family): string {
  const h = wire.replace(/^0x/, "").toLowerCase();
  if (family === "evm" && h.startsWith("01") && h.length === 2 + 40) return `0x${h.slice(2)}`;
  if ((family === "solana" || family === "jupnet") && h.startsWith("02") && h.length === 2 + 64) return base58(h.slice(2));
  if (family === "sui") return suiCoinFromWire(h) ?? wire;
  return wire;
}
